export default "__VITE_PUBLIC_ASSET__dcd66e26__"